<template>
  <v-container>
    <v-form ref="form" v-model="valid">
      <v-row>
        <v-select
          v-if="value"
          readonly
          @input="select"
          v-model="itemSelected"
          :items="items"
          :label="label"
          :item-text="itemText"
          :item-value="itemValue"
          @mousedown="selectClick"
          :loading="loading"
          :rules="required ? $isRequiredRule : []"
        ></v-select>

        <v-select
          v-if="!value"
          readonly
          @input="select"
          :items="items"
          :label="label"
          :item-text="itemText"
          :item-value="itemValue"
          :loading="loading"
          @mousedown="selectClick"
          :rules="required ? $isRequiredRule : []"
        ></v-select>

        <div class="pt-3">
          <v-btn icon @click="clear" color="primary">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-row>
    </v-form>
    <dialog-d
      ref="dialog"
      :title="label"
      :noActions="noActionsTable"
      :loading="loading"
      @alertClose="alert.alerts = []"
      :alert="alert"
    >
      <slot :selectedClick="selectedClick"></slot>
    </dialog-d>
  </v-container>
</template>

<script>
export default {
  props: {
    value: {},
    rules: {
      default() {
        return [];
      }
    },
    itemText: {},
    itemValue: {},
    clearable: {
      default() {
        return false;
      }
    },
    label: {
      default() {
        return "";
      }
    },
    noActionsTable: {
      default() {
        return true;
      }
    },
    loading: {
      default() {
        return false;
      }
    },
    required: {}
  },
  data() {
    return {
      valid: true,
      alert: { alerts: [], type: "error" },
      items: [],
      itemSelected: {}
    };
  },
  watch: {
    value() {
      if (this.value != null || this.value != {}) {
        this.items = [this.value];
        this.itemSelected = this.value;
        this.$refs.form.resetValidation();
      } else {
        this.$refs.form.resetValidation();
        this.items = [];
        this.itemSelected = null;
      }
    }
  },
  methods: {
    clear() {
      this.items = [];
      this.itemSelected = null;
      this.$emit("input", null);
      this.$emit("select", null);
    },
    isValid() {
      if (this.value === "") {
        this.itemSelected.length = 0;
        this.itemSelected = null;
      }

      return this.$refs.form.validate();
    },
    clearableClick() {
      this.$emit("select", null);
    },
    selectedClick(row) {
      this.$emit("input", row);
      this.$emit("select", row);
      this.items = [row];
      this.itemSelected = row;

      this.$refs.dialog.open();
    },
    selectClick() {
      if (!this.value) {
        this.items = [];
        this.itemSelected = {};
      }
      this.$refs.dialog.open();
    },
    select() {
      this.$emit(this.itemSelected);
    }
  },
  created() {
    if (this.value) {
      this.items = [this.value];
      this.itemSelected = [this.value];
    } else {
      this.items = [];
      this.itemSelected = null;
    }
  }
};
</script>